import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Pagination from '../../components/Pagination';
import { useNavigate } from 'react-router-dom';
import api from '../../services/Api';
import { formatShortDate, getEndDate } from '../../utils/Date';

const AllSubscription = () => {
  const navigate = useNavigate();
  const [people, setPeople] = useState([]);
  const [filteredPeople, setFilteredPeople] = useState([]);

  const { currentPage, entriesPerPage } = useSelector(state => state.pagination);
  const searchQuery = useSelector(state => state.search.query);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get('/analytics/subscriptions');
        setPeople(response.data.subscriptions);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  // Filter based on search query
  useEffect(() => {
    let filtered = people;

    if (searchQuery) {
      filtered = filtered.filter(user => {
        const nameMatch =
          user.businessDetails?.name?.toLowerCase().includes(searchQuery.toLowerCase()) || false;
        const emailMatch =
          user.businessDetails?.email?.toLowerCase().includes(searchQuery.toLowerCase()) || false;

        return nameMatch || emailMatch;
      });
    }

    setFilteredPeople(filtered);
  }, [people, searchQuery]);

  const totalEntries = filteredPeople.length;
  const paginatedUsers = filteredPeople.slice(
    (currentPage - 1) * entriesPerPage,
    currentPage * entriesPerPage
  );

  const handleViewReceipt = user => {
    navigate('/dashboard/receipt', {
      state: {
        transaction: user,
        headers: [
          { key: 'businessName', label: 'Business Name' },
          { key: 'email', label: 'Email' },
          { key: 'subscriptionType', label: 'Subscription Type' },
          { key: 'price', label: 'Price' },
          { key: 'startDate', label: 'Duration' },
          { key: 'status', label: 'Status' },
        ],
      },
    });
  };

  return (
    <div className="p-4 sm:ml-64 w-[80%] bg-[#F4F5F6] font-nohemi">
      <div className="flex justify-between items-center h-[64px]">
        <div className="ml-2 mb-3">
          <p className="font-normal text-xl text-[#191B1C]">Subscription Management</p>
        </div>
      </div>
      <div className="bg-white shadow-md p-4 rounded-lg">
        <div className="mb-2 ml-3">
          <h2 className="text-sm font-normal text-[#191B1C]">All Subscription</h2>
        </div>
        <div className="relative overflow-x-auto">
          <table className="w-full mx-auto text-left">
            <thead>
              <tr className="text-xs font-light text-[#808587] bg-[#F5F6F7]">
                <th className="p-3"></th>
                <th className="p-3">Name</th>
                <th className="p-3">Email</th>
                <th className="p-3">Subscription Type</th>
                <th className="p-3">Price</th>
                <th className="p-3">Duration</th>
                <th className="p-3">Status</th>
                <th className="p-3">Action</th>
              </tr>
            </thead>
            <tbody>
              {paginatedUsers.map((user, index) => (
                <tr key={user._id} className="border-b font-light text-[10px] text-[#4A5154]">
                  <td className="py-2 pl-6">
                    {' '}
                    <img
                      src={user.businessDetails?.media[0]?.fileUrl}
                      alt={`logo`}
                      className="w-6 h-6 mr-2 rounded-full"
                    />
                  </td>
                  <td className="py-2 pl-6">{user.businessDetails?.name}</td>
                  <td className="py-2 pl-6">{user.businessDetails?.customEmail}</td>
                  <td className="py-2 pl-6">{user.planDetails?.name}</td>
                  <td className="py-2 pl-6">{user.planDetails?.price}</td>
                  <td className="py-2 pl-6">
                    {formatShortDate(user.startDate)} -{' '}
                    {formatShortDate(getEndDate(user.startDate))}
                  </td>
                  <td className="">
                    <p
                      className={`rounded inline-flex items-center justify-center px-2.5 py-1 mx-3 m-4 text-center text-xs font-medium focus:ring-0 
                                  ${
                                    user.status === 'active'
                                      ? 'bg-[#E7F7EF] text-[#00A36C]'
                                      : user.status === 'inactive'
                                      ? 'bg-[#FEEFEF] text-[#E74C3C]'
                                      : 'bg-gray-300 text-gray-600'
                                  }`}>
                      {user.status}
                    </p>
                  </td>
                  <td className="p-2 ">
                    <button
                      onClick={() => handleViewReceipt(user)}
                      className="bg-black text-white px-2.5 py-1 cursor-pointer">
                      Download
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Pagination totalEntries={totalEntries} />
      </div>
    </div>
  );
};

export default AllSubscription;
